const ttl = 2 * 60 * 60 * 1000; // 2 horas
const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const searchEngines = ['google.', 'bing.', 'yahoo.', 'duckduckgo.', 'baidu.', 'yandex.', 'ask.', 'ecosia.'];

const params = new URLSearchParams(window.location.search);

function setWithExpire(key, value) {
    const now = new Date();
    const item = {
        value: value,
        expire: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpire(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expire) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

function isSocialSource(source) {
    if (!source) return false;

    const socialDomains = [
        'facebook.', 'instagram.', 'twitter.', 't.co', 'linkedin.', 'pinterest.', 'snapchat.',
        'reddit.', 'tumblr.', 'tiktok.', 'whatsapp.', 'messenger.', 'wechat.', 'vkontakte.'
    ];

    return socialDomains.some(domain => source.includes(domain));
}

function isExternalReferrer(referrer) {
    if (!referrer) return false;

    try {
        const referrerHost = new URL(referrer).hostname;
        const currentHost = window.location.hostname;

        // Considera externo se o domínio for diferente
        return referrerHost !== currentHost;
    } catch (error) {
        console.error("Erro ao processar referrer:", error);
        return false;
    }
}

function classifyByUtmMedium(utmMedium, utmSource) {
    if (utmMedium.includes('cpc') || utmMedium.includes('ppc') || utmMedium.includes('paidsearch')) {
        return 'Paid Search';
    }
    if (utmMedium.includes('paid social') || (utmMedium.includes('cpc') && isSocialSource(utmSource))) {
        return 'Paid Social';
    }
    if (utmMedium.includes('display') || utmMedium.includes('banner')) {
        return 'Display';
    }
    if (utmMedium.includes('email')) {
        return 'Email';
    }
    if (utmMedium.includes('affiliate')) {
        return 'Affiliates';
    }
    if (utmMedium.includes('sms')) {
        return 'SMS';
    }
    if (utmMedium.includes('push')) {
        return 'Mobile Push Notifications';
    }
    if (utmMedium.includes('video')) {
        return 'Organic Video';
    }
    if (utmMedium.includes('shopping') && utmMedium.includes('paid')) {
        return 'Paid Shopping';
    }
    if (utmMedium.includes('shopping') && !utmMedium.includes('paid')) {
        return 'Organic Shopping';
    }
    if (utmMedium.includes('native') || utmMedium.includes('paid other')) {
        return 'Paid Other';
    }
    return null;
}

function classifyByReferrer(referrer) {
    try {
        const referrerHost = new URL(referrer).hostname;
        if (searchEngines.some(engine => referrerHost.includes(engine))) {
            return 'Organic Search';
        }
        if (isSocialSource(referrerHost)) {
            return 'Organic Social';
        }
        return 'Referral';
    } catch (error) {
        console.error("Erro ao processar referrer:", error);
        return null;
    }
}

function getTrafficType(useCurrentReferrer = false) {
    const utmSource = getWithExpire('utm_source') || '';
    const utmMedium = getWithExpire('utm_medium') || '';
    const referrer = useCurrentReferrer ? document.referrer : (getWithExpire('first_referrer') || document.referrer);

    // Classificação baseada nos UTMs
    const utmClassification = classifyByUtmMedium(utmMedium, utmSource);
    if (utmClassification) {
        return utmClassification;
    }

    // Classificação baseada no referrer
    if (referrer) {
        const referrerClassification = classifyByReferrer(referrer);
        if (referrerClassification) {
            return referrerClassification;
        }
    }

    // Caso não se encaixe em nenhuma categoria, retorna "Unassigned"
    if (!utmSource && !utmMedium && !referrer) {
        return 'Unassigned';
    }

    // Se nenhum critério for atendido, classifica como Direct
    return 'Direct';
}

function storeUTMParams() {
    const sessionResetKeys = ['utm_source', 'utm_medium', 'utm_campaign'];
    let isNewSession = sessionResetKeys.some(param => params.has(param));

    if (isNewSession) {
        // Reseta UTMs porque é uma nova sessão, mas mantém o primeiro referrer
        // Reseta UTMs porque é uma nova sessão, mas mantém o primeiro referrer
        utmParams.forEach(param => localStorage.removeItem(param));
        
        // Remover o primeiro referrer apenas se for uma nova sessão
        localStorage.removeItem('first_referrer');
    }
    
    const existingReferrer = getWithExpire('first_referrer');
    // Só armazena se não existe um referrer salvo E se o referrer atual é externo
    if (!existingReferrer && document.referrer && isExternalReferrer(document.referrer)) {
        setWithExpire('first_referrer', document.referrer);
    }

    // Persistir os novos valores
    utmParams.forEach(param => {
        if (params.has(param)) {
            setWithExpire(param, params.get(param));
        }
    });
}

function addUTMParamsToForm(form) {
    // Verifica se há novos parâmetros UTM na URL atual
    const hasNewUTMParams = ['utm_source', 'utm_medium', 'utm_campaign'].some(param => params.has(param));

    [...utmParams, 'utm_traffic_type'].forEach(param => {
        const value = param === 'utm_traffic_type'
            ? getTrafficType(hasNewUTMParams) // Passa true se há novos UTMs
            : getWithExpire(param);

        if (value && !form.querySelector(`input[name="${param}"]`)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = param;
            input.value = value;
            form.appendChild(input);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    storeUTMParams();
});

export { addUTMParamsToForm };